import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {uniq, sortBy} from 'lodash';
import { Form, Dropdown } from 'semantic-ui-react';
import {intersection} from 'lodash';

/*
* @augments {ItemFilterForm<{ items:array, onFilterChange:function>}
*/
export default class ItemFilterForm extends Component {

    constructor() {
        super();

        this.state = {
            tags: [],
            filter: [],
        };
    }

    handleChange = (e, { searchQuery, value }) => {
        const {onFilterChange} = this.props;

        if(onFilterChange) {
            onFilterChange(value);
        }
    }

    componentDidMount() {
        const {items, filter} = this.props;

        const tags = this.getTags(items, filter);

        this.setState({
            tags: tags,
            filter: filter,
        });
    }

    render() {
        const {items, filter} = this.props;

        const tags = this.getTags(items, filter)

        const tagOptions = tags.map( t => {return { key: t, value: t, text: t}} );

        return (
            <Form action="">
                <Form.Group>
                    <Form.Field>
                        <label>Filter</label>
                        <Dropdown placeholder='Enter filter tags here' multiple search selection options={tagOptions} onChange={this.handleChange} />
                    </Form.Field>
                </Form.Group>
            </Form>
        )
    }

    getTags = (items, filter) => {

        let tags = sortBy(uniq(items.map( x => x.Tags ).reduce( (prior, current) => prior.concat(current), [])));

        if(filter && filter.length > 0) {
            tags = intersection(tags, filter);
        }

        return tags;
    }
}

ItemFilterForm.propTypes = {
    items: PropTypes.array.isRequired,
    filter: PropTypes.arrayOf(PropTypes.string),
    onFilterChange: PropTypes.func,
};


// WEBPACK FOOTER //
// ./src/common/items/ItemFilterForm.jsx